import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2106274e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "mediacalBox" }
const _hoisted_4 = { class: "mediacalBack" }
const _hoisted_5 = { class: "mediaclText" }
const _hoisted_6 = { class: "left" }
const _hoisted_7 = { class: "wenjianjia" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"sex\" data-v-2106274e>女，79岁</div><div class=\"xiegang\" data-v-2106274e>////////////////////////</div><div class=\"bottomBoxx\" data-v-2106274e><div class=\"clue\" data-v-2106274e>  主   诉</div><div class=\"mainTail\" data-v-2106274e><ul data-v-2106274e><li data-v-2106274e>全身发疹伴痒3年余，加重半年余</li></ul></div></div>", 3)
const _hoisted_11 = { class: "right" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "clue2" }, "既往病史")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "boxTail" }, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "3年前患者出现全身发疹伴痒，经多次问诊"),
    /*#__PURE__*/_createElementVNode("li", null, "仍未很好的控制，最初症状是")
  ])
], -1))
const _hoisted_14 = { class: "bottomBoxx" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "leftBoxx" }, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "★ 全身有粟粒大小丘疹、丘疱疹或小水疱"),
    /*#__PURE__*/_createElementVNode("li", null, "★ 伴有瘙痒"),
    /*#__PURE__*/_createElementVNode("li", null, "★ 明显浆液渗出"),
    /*#__PURE__*/_createElementVNode("li", null, "★ 反复发作")
  ])
], -1))
const _hoisted_16 = { class: "rightBox" }
const _hoisted_17 = { class: "rightImg" }
const _hoisted_18 = { class: "btnBox" }
const _hoisted_19 = { class: "bxs" }
const _hoisted_20 = { class: "ip" }
const _hoisted_21 = {
  style: {"width":"4rem","margin":"0 auto"},
  class: "home"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_question = _resolveComponent("question")!
  const _component_jieGuo = _resolveComponent("jieGuo")!
  const _component_correct = _resolveComponent("correct")!
  const _component_reason = _resolveComponent("reason")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_image, {
          width: "2.3733rem",
          height: ".52rem",
          src: require('../assets/newlogo.png')
        }, null, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_van_image, {
                  width: "1.8533rem",
                  height: "1.5867rem",
                  src: require('../assets/wenjianjia.png')
                }, null, 8, ["src"])
              ]),
              _hoisted_8
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_van_image, {
                width: "2.0933rem",
                height: "2.12rem",
                src: require('../assets/laonai.png')
              }, null, 8, ["src"])
            ])
          ]),
          _hoisted_12,
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_van_image, {
                  width: "4.52rem",
                  height: "4.4267rem",
                  src: require('../assets/shen.png')
                }, null, 8, ["src"])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_van_image, {
            onClick: $options.showPopup,
            width: "3.1467rem",
            height: "3.68rem",
            src: require('../assets/xiansheng.png')
          }, null, 8, ["onClick", "src"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_van_image, {
            onClick: $options.showPopup,
            width: "5.2933rem",
            height: "1.56rem",
            src: require('../assets/shenmebing.png')
          }, null, 8, ["onClick", "src"]),
          _createVNode(_component_van_image, {
            class: "finger",
            width: "1.28rem",
            height: "1.28rem",
            src: require('../assets/dong.gif')
          }, null, 8, ["src"])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_van_popup, {
          show: $data.show,
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($data.show) = $event))
        }, {
          default: _withCtx(() => [
            ($data.flag == 'question')
              ? (_openBlock(), _createBlock(_component_question, {
                  key: 0,
                  onOnChanged: $options.updateChanged,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true),
            ($data.flag == 'jieGuo')
              ? (_openBlock(), _createBlock(_component_jieGuo, {
                  key: 1,
                  onOnChanged: $options.updateChanged,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true),
            ($data.flag == 'correct')
              ? (_openBlock(), _createBlock(_component_correct, {
                  key: 2,
                  onOnChanged: $options.updateCorrect,
                  postaimqus: $data.postaimqus,
                  correct: $data.correct
                }, null, 8, ["onOnChanged", "postaimqus", "correct"]))
              : _createCommentVNode("", true),
            ($data.flag == 'reason')
              ? (_openBlock(), _createBlock(_component_reason, {
                  key: 3,
                  onOnChanged: $options.reasonCorrect,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ]),
    _createVNode(_component_toNav, { menu: 1 })
  ], 64))
}